<template>
  <div class="pageview">
    <!-- 查询表单 -->
    <div class="query-form">
      <van-cell-group inset>
        <van-field
          v-model="queryParams.name"
          label="姓名"
          placeholder="请输入姓名"
          clearable
          @keypress.enter="handleQuery"
        />
        <van-field
          v-model="queryParams.userId"
          label="手机号"
          placeholder="请输入手机号"
          clearable
          @keypress.enter="handleQuery"
        />

        <!-- 日期范围选择 -->
        <van-field
          readonly
          clickable
          label="日期范围"
          :value="dateRangeDisplay"
          placeholder="选择开始和结束日期"
          @click="showCalendar = true"
        />
      </van-cell-group>

      <!-- 操作按钮 -->
      <div class="query-actions">
        <van-button type="primary" size="small" @click="queryFun">查询</van-button>
        <van-button size="small" @click="resetQuery">重置</van-button>
        <van-button type="primary" size="small" @click="$refs.searchInfo.addCreateForm(platForm)">人脸搜索</van-button>
        <van-button type="primary" plain size="small" @click="$refs.addFaceDatabase.addCreateForm(oriApi, userName, platForm)">
          新增
        </van-button>
      </div>
    </div>

    <!-- 日历选择（支持范围） -->
    <van-calendar
      v-model="showCalendar"
      type="range"
      @confirm="onDateConfirm"
      color="#1989fa"
    />

    <!-- 下拉刷新 + 触底加载 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <!-- 人脸列表 -->
        <div class="faceDatabase">
          <div
            class="faceDatabase_box"
            v-for="(item, index) in dataList"
            :key="index"
            @click="$refs.details.addCreateForm(item)"
          >
            <div class="faceDatabase_box_imgBox">
              <img :src="item.url" class="faceDatabase_box_img" alt="头像" />
            </div>
            <span class="faceDatabase_box_name">
              {{ item.userName }}
              <span class="faceDatabase_box_phone">({{ item.userPhone }})</span>
            </span>
            <span class="faceDatabase_box_time">{{ item.createTime }}</span>
            <span class="faceDatabase_box_time" v-if="!searchShow">相似度：{{ item.score }}%</span>
            <div class="faceDatabase_box_btnBox">
              <van-button
                size="mini"
                type="primary"
                round
                plain
                @click.stop="$refs.addFaceDatabase.addFaceForm(item)"
              >
                新增人脸
              </van-button>
              <van-button
                size="mini"
                type="danger"
                round
                plain
                @click.stop="handleDelete(item)"
              >
                删除
              </van-button>
            </div>
          </div>

          <!-- 空状态 -->
          <van-empty description="暂无内容" v-if="dataList.length === 0 && !loading && !refreshing" />
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 子组件 -->
    <addFaceDatabaseVant ref="addFaceDatabase" @ok="onRefresh" />
    <detailsVant ref="details" />
    <searchInfoVant ref="searchInfo" @ok="handleQuery" />
  </div>
</template>

<script>
import { getfaceLibraryList, faceLibrarydelUser } from "@/api/faceDatabase";
import addFaceDatabaseVant from "@/views/system/faceDatabase/addFaceDatabaseVant";
import detailsVant from "@/views/system/faceDatabase/detailsVant";
import searchInfoVant from "@/views/system/faceDatabase/searchInfoVant";

export default {
  components: {
    addFaceDatabaseVant,
    detailsVant,
    searchInfoVant,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
        userId: "",
        beginTime: "",
        name: "",
        endTime: "",
      },
      total: 0,
      dataList: [],
      platForm: "",
      userName: "",
      oriApi: "",
      searchShow: true,
      dateRange: [], // [开始, 结束]
      showCalendar: false,
      loading: false,
      refreshing: false,
      finished: false, // 是否已加载完成
    };
  },
  computed: {
    dateRangeDisplay() {
      if (this.dateRange && this.dateRange.length === 2) {
        return `${this.formatDate(this.dateRange[0])} - ${this.formatDate(this.dateRange[1])}`;
      }
      return "";
    },
  },
  mounted() {
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;
    this.oriApi = this.$route.query.oriApi;
    this.queryParams.platForm = this.platForm;
    this.getList(); // 首次加载
  },
  methods: {
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 日历确认选择
    onDateConfirm(dateRange) {
      const [start, end] = dateRange;
      this.dateRange = [start, end];
      this.queryParams.beginTime = this.formatDate(start);
      this.queryParams.endTime = this.formatDate(end);
      this.showCalendar = false;
      this.queryFun(); // 选择后自动查询
    },

    // 查询（重置页码）
    queryFun() {
      this.queryParams.pageNum = 1;
      this.dataList = [];
      this.finished = false;
      this.getList();
    },

    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.queryParams.pageNum = 1;
      this.dataList = [];
      this.finished = false;
      this.getList(false);
    },

    // 触底加载更多
    onLoad() {
      // 防止重复加载
      if (this.finished || this.loading) return;
      this.getList();
    },

    // 获取列表
    getList(loading = true) {
      if (loading) {
        this.loading = true;
      }

      getfaceLibraryList(this.queryParams)
        .then((response) => {
          const result = response.data.data;
          const list = result.list || [];

          // 解析 userInfo
          list.forEach((item) => {
            if (item.userInfo) {
              try {
                item.userInfo = JSON.parse(item.userInfo);
                item.userName = item.userInfo.name;
                item.userPhone = item.userInfo.id;
              } catch (e) {
                console.warn('解析 userInfo 失败', item.userInfo);
              }
            }
            // 处理 score
            if (item.score !== undefined) {
              item.score = this.toTwoDecimalRegex(item.score * 1);
            }
          });

          // 合并数据
          if (this.queryParams.pageNum === 1) {
            this.dataList = list;
          } else {
            this.dataList.push(...list);
          }

          this.total = result.total;

          // 判断是否还有更多
          if (this.dataList.length >= this.total) {
            this.finished = true;
          } else {
            this.queryParams.pageNum += 1;
          }
        })
        .catch(() => {
          this.$toast.fail('加载失败');
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },

    // 图片搜索回调
    handleQuery(list) {
      this.searchShow = false;
      list.forEach((item) => {
        if (item.userInfo) {
          try {
            item.userInfo = JSON.parse(item.userInfo);
            item.userName = item.userInfo.name;
            item.userPhone = item.userInfo.id;
          } catch (e) {
            console.warn('解析 userInfo 失败', item.userInfo);
          }
          item.score = this.toTwoDecimalRegex(item.score * 1);
        }
      });
      this.dataList = list;
      this.finished = true; // 图片搜索不支持分页
    },

    // 删除
    handleDelete(row) {
      const ids = row.id;
      this.$dialog.confirm({
        title: '提示',
        message: `是否确认删除编号为 "${ids}" 的数据项？`,
      })
        .then(() => faceLibrarydelUser({ id: ids }))
        .then(() => {
          this.$toast.success('删除成功');
          this.onRefresh(); // 刷新列表
        })
        .catch(() => {});
    },

    // 重置
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        userId: "",
        beginTime: "",
        endTime: "",
        name: "",
      };
      this.dateRange = [];
      this.queryFun();
    },

    toTwoDecimalRegex(value) {
      let num = parseFloat(value);
      return num ? num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : '0';
    },
  },
};
</script>

<style scoped>
.pageview {
  padding: 10px;
  font-size: 14px;
  min-height: 100vh;
  background: #f7f8fa;
  height: 100vh;
  overflow-y: auto;
}

.query-form {
  margin-bottom: 16px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.query-actions {
  padding: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  background: #f9f9f9;
}

.faceDatabase {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-start;
}

.faceDatabase_box {
  width: 40%;
  min-width: 130px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  cursor: pointer;
  background-image: url("https://beauty-hair.oss-cn-beijing.aliyuncs.com/hairImg/bee0.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.faceDatabase_box:nth-child(2n) {
  margin-right: 0;
}

.faceDatabase_box_imgBox {
  width: 64px;
  height: 64px;
  background: linear-gradient(151deg, #c1d7fd 0%, #dbc7fe 100%);
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.faceDatabase_box_img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.faceDatabase_box_name {
  display: block;
  margin: 8px 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  word-break: break-all;
}

.faceDatabase_box_phone {
  font-size: 12px;
  color: #666;
}

.faceDatabase_box_time {
  display: block;
  margin: 4px 0;
  color: #999;
  font-size: 12px;
}

.faceDatabase_box_btnBox {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 6px;
}

.van-button--mini {
  font-size: 12px;
  padding: 0 8px;
  height: 24px;
}

.van-empty {
  width: 100%;
  margin: 40px 0;
}
</style>